import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import {
    MailGreen,
    TelephoneGreen
} from '../../assets/images/index.js';

export default class ContactTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  photoIndex: 0,
		  isOpen: false
		};
	}
	render() {
		const { isOpen } = this.state;
		return (
			<div id={this.props.tabId} className={"contact__tab-content-tab " + this.props.extraClasses}>
          <h4>{this.props.department}</h4>
          <p className="contact__tab-introText">
          	{this.props.departmentDescription}
          </p>
          <div className="flex flex-wrap flex-justify mt30">
              <ul className="contact__tab-list">
                  {this.props.email1 && (
                  <li>
                  	{this.props.name1 && (
                			<span>{this.props.name1}</span>
                		)}
                    <a href={"mailto:" + this.props.email1}><MailGreen/>{this.props.email1}</a>
                    {this.props.phone1 && (
                    	<a href={"tel:+31" + this.props.phone1.replace(/[^\w\s]/gi, '').replace(/\s/g,'')}><TelephoneGreen/>{this.props.phone1}</a>
                    )}
                  </li>
                  )}
                  {this.props.email2 && (
                  <li>
                		{this.props.name2 && (
                			<span>{this.props.name2}</span>
                		)}
                    <a href={"mailto:" + this.props.email2}><MailGreen/>{this.props.email2}</a>
                    {this.props.phone2 && (
                    <a href={"tel:+31" + this.props.phone2.replace(/[^\w\s]/gi, '').replace(/\s/g,'')}><TelephoneGreen/>{this.props.phone2}</a>
                    )}
                  </li>
                  )}
                  {this.props.email3 && (
                  <li>
	                  {this.props.name3 && (
                			<span>{this.props.name3}</span>
                		)}
                    <a href={"mailto:" + this.props.email3}><MailGreen/>{this.props.email3}</a>
                    {this.props.phone3 && (
                    <a href={"tel:+31" + this.props.phone3.replace(/[^\w\s]/gi, '').replace(/\s/g,'')}><TelephoneGreen/>{this.props.phone3}</a>
                    )}
                  </li>
                  )}
              </ul>
              <div>
                  <img src={this.props.image} alt={this.props.image} onClick={() => this.setState({ isOpen: true })}/>
              </div>
          </div>
          {isOpen && (
          <Lightbox
            mainSrc={this.props.image}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ContactCategories/ContactTab.jsx